class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    try {
      const form = document.getElementById(this.dataset.formId);
      if (!form) return;

      const primaryBtn = form.querySelector('[name="add"]');
      if (!primaryBtn) return;

      this.primaryBtn = primaryBtn;
      this.stickyBtn = this.querySelector('.sticky-atc__btn');

      this.update = () => {
        const show = primaryBtn.getBoundingClientRect().bottom <= 0;
        this.hidden = !show;
        document.body.classList.toggle('has-sticky-atc', show);
      };

      // rAF-throttled scroll listener: catches every scroll change including
      // browser scroll-restoration after reload, which IntersectionObserver misses
      // when the target stays not-intersecting across the restoration.
      let ticking = false;
      this.scrollHandler = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          this.update();
          ticking = false;
        });
      };
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
      window.addEventListener('resize', this.scrollHandler, { passive: true });

      // Initial sync — and re-sync next frame to catch post-load scroll restoration.
      this.update();
      requestAnimationFrame(this.update);

      this.mirror = new MutationObserver(() => this.syncState());
      this.mirror.observe(primaryBtn, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
        childList: true,
        subtree: true,
      });
      this.syncState();
    } catch (err) {
      console.warn('[sticky-add-to-cart]', err);
    }
  }

  syncState() {
    if (!this.stickyBtn || !this.primaryBtn) return;
    this.stickyBtn.disabled = this.primaryBtn.disabled;
    const label = this.stickyBtn.querySelector('.sticky-atc__label');
    const primaryLabel = this.primaryBtn.querySelector('span');
    if (label && primaryLabel && primaryLabel.textContent.trim()) {
      label.textContent = primaryLabel.textContent.trim();
    }
  }

  disconnectedCallback() {
    this.mirror?.disconnect();
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.scrollHandler);
    }
    document.body.classList.remove('has-sticky-atc');
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
